export default __webpack_public_path__ + "static/media/pay respects 11.ca46eb8d.png";